var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Sidebar file properties component
 * @author Box
 */

import React from 'react';
import getProp from 'lodash/get';
import { injectIntl } from 'react-intl';
import ItemProperties from 'box-react-ui/lib/features/item-details/ItemProperties';
import LoadingIndicatorWrapper from 'box-react-ui/lib/components/loading-indicator/LoadingIndicatorWrapper';
import getFileSize from 'box-react-ui/lib/utils/getFileSize';
import withErrorHandling from './withErrorHandling';
import { FIELD_METADATA_CLASSIFICATION, KEY_CLASSIFICATION_TYPE } from '../../constants';
import { INTERACTION_TARGET, DETAILS_TARGETS } from '../../interactionTargets';

/**
 * Gets the openModal prop for ItemProperties
 *
 * @param {Object} file the box file
 * @param {Function} onClassificationClick the optional callback
 * @returns {Function|undefined} the callback function if it is passed in, and the user has permissions
 */
export var getClassificationModal = function getClassificationModal(file, onClassificationClick) {
    // Changing classification requires edit metadata permission, which is included in can_upload
    if (onClassificationClick && getProp(file, 'permissions.can_upload', false)) {
        return onClassificationClick;
    }

    return undefined;
};

var SidebarFileProperties = function SidebarFileProperties(_ref) {
    var file = _ref.file,
        onDescriptionChange = _ref.onDescriptionChange,
        hasClassification = _ref.hasClassification,
        onClassificationClick = _ref.onClassificationClick,
        hasRetentionPolicy = _ref.hasRetentionPolicy,
        retentionPolicy = _ref.retentionPolicy,
        bannerPolicy = _ref.bannerPolicy,
        onRetentionPolicyExtendClick = _ref.onRetentionPolicyExtendClick,
        isLoading = _ref.isLoading,
        intl = _ref.intl;

    var value = getProp(file, FIELD_METADATA_CLASSIFICATION + '.' + KEY_CLASSIFICATION_TYPE);

    return React.createElement(
        LoadingIndicatorWrapper,
        { isLoading: isLoading },
        React.createElement(ItemProperties, {
            createdAt: file.created_at,
            description: file.description,
            modifiedAt: file.modified_at,
            owner: getProp(file, 'owned_by.name'),
            size: getFileSize(file.size, intl.locale),
            uploader: getProp(file, 'created_by.name'),
            onDescriptionChange: getProp(file, 'permissions.can_rename') ? onDescriptionChange : undefined,
            descriptionTextareaProps: _defineProperty({}, INTERACTION_TARGET, DETAILS_TARGETS.DESCRIPTION),
            classificationProps: hasClassification ? _defineProperty({
                openModal: getClassificationModal(file, onClassificationClick),
                tooltip: getProp(bannerPolicy, 'body'),
                value: value
            }, INTERACTION_TARGET, value ? DETAILS_TARGETS.CLASSIFICATION_EDIT : DETAILS_TARGETS.CLASSIFICATION_ADD) : {},
            retentionPolicyProps: hasRetentionPolicy ? _extends({}, retentionPolicy, {
                openModal: onRetentionPolicyExtendClick
            }) : {}
        })
    );
};

export { SidebarFileProperties as SidebarFilePropertiesComponent };
export default injectIntl(withErrorHandling(SidebarFileProperties));